<template>
  <transition name='fade'>
    <div
      class="modal app_view"
      v-if='visible'
    >
      <div class="app_view_phone">
        <div class="app_view_inner">
          <div class="top_img">
            <img
              src="../../../static/img/phonetop.png"
              alt=""
            >
          </div>
          <div
            class="app_view_content"
            v-loading='iframeloading'
            element-loading-text="加载中"
          >
            <iframe
              :src="iframeSrc"
              frameborder="0"
              @load="loadIframe"
            ></iframe>
          </div>
        </div>
        <div
          class="close_button"
          @click.stop='closeBox()'
        >
          <img
            src='../../../static/img/appviewclose.png'
            alt=""
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'previewApp',
  data () {
    return {
      visible: false,
      iframeSrc: '',
      iframeloading: false
    }
  },
  mounted () {
    this.$root.eventHub.$on('previewAppModel', (data) => {
      this.visible = true
      this.iframeloading = true
      this.iframeSrc = _API_ + 'api/article/utils/preview_app_article' + '?token=' + this.$store.state.userinfo.token + '&company_id=' + this.$store.state.userinfo.company_id + '&id_article=' + data.id
    })

  },
  destroyed () {
    this.$root.eventHub.$off('previewAppModel')
  },
  components: {

  },
  methods: {
    closeBox () {
      this.visible = false
    },
    loadIframe (data) {
      this.iframeloading = false
    }

  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.app_view
  .app_view_phone
    position relative
    box-sizing border-box
    padding 18px
    width 360px
    height 727px
    background url('../../../static/img/phoneouter.png') no-repeat 0 0
    background-size 100% 100%

    .app_view_inner
      width 100%
      height 100%
      background url('../../../static/img/phoneinner.png') no-repeat 0 0
      background-size 100% 100%

      .top_img
        display flex
        justify-content center
        width 100%

      .app_view_content
        overflow hidden
        height calc(100% - 60px)

        iframe
          width 100%
          height 100%

    .close_button
      position absolute
      top -20px
      right -20px
      width 30px
      height 30px
      cursor pointer

      img
        width 100%
        height 100%

@media (max-width 1600px)
  .app_view .app_view_phone
    height 92%
</style>
